
import React, { useState, useEffect } from "react";
import { RCCButton,  RCCInput, RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { IComponentLinkItem} from "src/pages/Occurrences/Panel/interface";

const LinkItem:  React.FC<IComponentLinkItem> = ({
	id,
	index,
	link,
	remove,
	error,
	disabled,
	register
}) => {
	const { translate} = useTranslation();

	const [linkButtonText, setLinkButtonText] = useState<string | undefined>(undefined);
    
	const onBlurCaptureLink = (val: string) => {
		if(val.trim().length === 0){
			setLinkButtonText(undefined);
			return;
		}
		if(!val.includes("http://") && !val.includes("https://")){
			setLinkButtonText(`https://${val.trim()}`);
			return;
		}
		setLinkButtonText(val.trim());
	};

	useEffect(() => {
		if(!link) {
			return;
		} 
		if(!link.includes("http://") && !link.includes("https://")) {
			setLinkButtonText(`https://${link}`); 
			return; 
		} 
		setLinkButtonText(link);
	}, []);


	return (
		<>
			<div
				style={{ display: "flex", width: "100%", alignItems: "baseline", justifyContent: "center" }}
			>
				<RCCInput 
					register={register}
					name={`octbb005[${index}].ocb005LinkExterno`}
					label={translate("Link externo")}
					maxLength={1000}
					defaultValue={link ?? ""}
					onBlurCapture={(e) => onBlurCaptureLink(e.target.value)}
					error={error.octbb005 && error.octbb005[index]?.ocb005LinkExterno}
					disabled={disabled}
					style={{ width: "calc(100% - 35px)" }}
				/>
				<RCCTooltip
					text={translate("Abrir link externo")}
					color={linkButtonText? "purple": "grey"}
				>	
					<RCCButton
						icon={{name: "linkExternal"}}
						onClick={() => window.open(linkButtonText, "_blank")}
						layout="isRounded"
						color={linkButtonText? "purple": "grey"}
						disabled={!linkButtonText}
					/>
				</RCCTooltip>
				<RCCTooltip
					text={translate("Remover link")}
					color="red"
				>	
					<RCCButton
						icon={{name: "trash"}}
						color="red"
						onClick={() => {
							remove(index);
						}}
						disabled={disabled}
						layout="isRounded"
					/>
				</RCCTooltip>
			</div>
			<input 
				type="text"
				value={String(id)}
				{...register(`octbb005[${index}].ocb005Id`)} 
				style={{display: "none"}}
				readOnly
			/>
		</>
	);
};




export default LinkItem;
